// @flow
import createReducer from '../utils/createReducer';
import {REDIRECT_PERFORM} from '../actions/redirect';
import type {Action, ActionType} from '../actions/redirect';
import type {ActionHandlers} from './ActionHandlers';

export type State = {
    +isRedirecting: boolean,
    +url: string
};

const initialState = {isRedirecting: false};

/* NOTE: redirectInterceptor middleware handles the actual redirecting */
const actionHandlers: ActionHandlers<Action, ActionType, State> = {
    [REDIRECT_PERFORM](state, {payload: {url}}) {
        return {isRedirecting: true, url};
    }
};

export default createReducer(actionHandlers, initialState);
